// extracted by mini-css-extract-plugin
export default {"cls1":"FormButtons-OnboardingContinueButton_cls1__TiiPp","cls2":"FormButtons-OnboardingContinueButton_cls2__GEEyG FormButtons-OnboardingContinueButton_cls1__TiiPp"};